import "../App.css";
import sideProjects from "../assets/data/side-projects.json";
import blogPosts from "../assets/data/blog-posts.json";

export default function Extras() {
  return (
    <div
      className="tab-pane fade extras"
      id="extras-tab-pane"
      role="tabpanel"
      aria-labelledby="extras-tab"
      tabIndex="0"
    >
      <div className="container-fluid">
        <div className="row">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                <small>
                  <code>$ ~/portfolio/src/components/Extras.js</code>
                </small>
              </li>
            </ol>
          </nav>
        </div>
        <h5 className="py-4">
          This is page contains&nbsp;
          <span className="extras-link">side projects</span> that I enjoyed
          working on and ultimately learned a lot from, and&nbsp;
          <span className="extras-link">blog posts</span> that are good reads.
        </h5>

        <div className="accordion accordion-flush" id="extrasAccordion">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-side-projects"
                aria-expanded="false"
                aria-controls="flush-side-projects"
              >
                <h4 className="mb-0">Side Projects</h4>
              </button>
            </h2>
            <div
              id="flush-side-projects"
              className="accordion-collapse collapse show"
              data-bs-parent="#extrasAccordion"
            >
              <div className="accordion-body">
                <div className="row">
                  {sideProjects.map((project) => (
                    <div key={project.id} className="col-12 col-md-4 px-3 mb-4">
                      <div
                        className="card text-center"
                        card-type={project.type + "-project"}
                      >
                        {/* <div className="card-img-top">
                          <iframe
                            src={project.link}
                            width="100%"
                            height="200"
                            frameBorder="0"
                            title={project.title}
                          ></iframe>
                        </div> */}
                        <div className="card-body p-5">
                          <h5 className="card-title">{project.title}</h5>
                          <p className="card-text">{project.description}</p>
                          <a
                            href={project.link}
                            target="_blank"
                            rel="noreferrer"
                            style={{ width: "80%" }}
                            className="btn btn-primary btn-custom mx-auto"
                          >
                            {"visit " + project.type + " link "}
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-blog-posts"
                aria-expanded="false"
                aria-controls="flush-blog-posts"
              >
                <h4 className="mb-0">Blog Posts</h4>
              </button>
            </h2>
            <div
              id="flush-blog-posts"
              className="accordion-collapse collapse"
              data-bs-parent="#extrasAccordion"
            >
              <div className="accordion-body">
                <ul className="list-group">
                  {blogPosts.map((post) => (
                    <a
                      key={post.id}
                      className="link-underline-dark"
                      href={post.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <li className="list-group-item d-flex justify-content-between align-items-center b-0 my-3">
                        <div className="ms-2 me-auto">
                          <div className="blog-post-title fw-bold">
                            {post.title}&nbsp;
                            <small>
                              <i className="fa-solid fa-up-right-from-square"></i>
                            </small>
                          </div>
                          <span className="blog-post-description">
                            {post.description}
                          </span>
                        </div>
                        <p className="blog-site text-center m-0 d-none d-md-block">
                          <i className={"fa-brands fa-" + post.blogSite}></i>
                          <br />
                          {post.blogSite}
                        </p>
                      </li>
                    </a>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
